import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../context/LanguageContext";

const CtaBanner = () => {
  const { t } = useLanguage();

  return (
    <section className="py-24 md:py-32 bg-white dark:bg-[#051518] text-gray-900 dark:text-slate-100 text-center px-6 relative overflow-hidden transition-colors duration-300">
      <div className="max-w-4xl mx-auto relative z-10">
        {/* Main Heading */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-gray-900 dark:text-white leading-tight mb-6">
          {t.cta.heading}
        </h2>

        {/* Subtext */}
        <p className="text-gray-600 dark:text-slate-300 text-base md:text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
          {t.cta.subtext}
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/contact"
            className="px-8 py-4 bg-[#0F4C5C] dark:bg-[#E09F3E] hover:bg-[#0a3844] dark:hover:bg-[#c98e35] text-white dark:text-[#0A2E36] font-bold rounded-full transition-all duration-300 shadow-md inline-flex items-center"
          >
            {t.cta.bookNow}
            <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M17 8l4 4m0 0l-4 4m4-4H3" />
            </svg>
          </Link>
          <a
            href="tel:+916281785274"
            className="px-8 py-4 border border-gray-300 dark:border-white/10 text-gray-800 dark:text-slate-200 font-medium rounded-full hover:bg-gray-100 dark:hover:bg-white/10 transition-all duration-300"
          >
            +91 62817 85274
          </a>
        </div>
      </div>
    </section>
  );
};

export default CtaBanner;
